import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { GameProvider } from "./context/GameContext";
import Navbar from "./components/Navbar";
import Celebration from "./components/Celebration";
import Notification from "./components/Notification";
import LevelUpAnimation from "./components/LevelUpAnimation";
import Home from "./pages/Home";
import WeekSummary from "./pages/WeekSummary";
import Arsenal from "./pages/Arsenal";
import About from "./pages/About";
import Playbook from "./pages/Playbook";
import Login from "./pages/Login";
import { supabase } from "./supabaseClient";
import "./index.css";

export default function App() {
  const [session, setSession] = useState(null);
  const [loading, setLoading] = useState(true);
  const [theme, setTheme] = useState(localStorage.getItem("telious-theme") || "dark");

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session);
      setLoading(false);
    });
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session);
    });
    return () => subscription.unsubscribe();
  }, []);

  useEffect(() => {
    document.body.setAttribute("data-theme", theme);
    localStorage.setItem("telious-theme", theme);
  }, [theme]);

  const toggleTheme = () => setTheme(prev => prev === "dark" ? "light" : "dark");

  if (loading) return <div className="loading-screen">LOADING...</div>;
  if (!session) return <Login />;

  return (
    <GameProvider>
      <BrowserRouter>
        <div className="app">
          <Navbar session={session} toggleTheme={toggleTheme} theme={theme} />
          <main className="main-content">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/coach" element={<WeekSummary />} />
              <Route path="/arsenal" element={<Arsenal />} />
              <Route path="/playbook" element={<Playbook />} />
              <Route path="/about" element={<About />} />
            </Routes>
          </main>
          <Celebration />
          <Notification />
          <LevelUpAnimation />
        </div>
      </BrowserRouter>
    </GameProvider>
  );
}
